import React, { useState } from 'react'
import { Icon } from '@iconify/react'
import { Button } from '@pepper/ui'

import { useGetWorkflowOnOffState } from 'utils/hooks/workflows/useGetWorkflowToggledState'
import { useSelectedCompanyId } from 'utils/functions/misc'
import { DecodedQueryParamFilters } from 'components/items/FilterParams'

import StatusFilter from '../StatusFilter'
import VerticalFilter from '../VerticalFilter'
import ReworkFilter from '../ReworkFilter/'
import WorkflowStatusFilter from '../WorkflowStatusFilter'
import WorkflowAssigneeFilter from '../WorkflowAssigneeFilter'
import s from './Filters.module.css'

type Props = {
  queryParamFilters: DecodedQueryParamFilters
  disableMarketplaceFilters: boolean
  isEmptyItems?: boolean
  clearAllFilters: () => void
}

const Filters: React.FC<Props> = ({
  disableMarketplaceFilters,
  queryParamFilters,
  isEmptyItems,
  clearAllFilters,
}) => {
  const companyId = useSelectedCompanyId()
  const { data: isWorkflowEnabled } = useGetWorkflowOnOffState({ companyId })
  const { stage, rework, vertical, assignee, status } = queryParamFilters
  const isNoFilterApplied =
    assignee.length === 0 &&
    status.length === 0 &&
    !stage &&
    !rework &&
    !vertical
  const [expandFilters, setExpandFilters] = useState(!isNoFilterApplied)

  const handleClick = () => {
    setExpandFilters(true)
  }

  const handleClear = () => {
    clearAllFilters()
    setExpandFilters(false)
  }

  const hidePvtDocFilter =
    disableMarketplaceFilters && isWorkflowEnabled?.data.workflow_enabled === 0

  return (
    <div className={s.filters}>
      {!expandFilters && !hidePvtDocFilter && (
        <Button
          className={s.filterDisplayBtn}
          size="small"
          onClick={handleClick}
          disabled={isEmptyItems}
        >
          <Icon icon="lucide:filter" />
          Filters
        </Button>
      )}
      {expandFilters && (
        <>
          {!disableMarketplaceFilters && (
            <>
              <StatusFilter />
              <VerticalFilter />
              <ReworkFilter />
            </>
          )}
          {isWorkflowEnabled?.data.workflow_enabled === 1 && (
            <>
              <WorkflowStatusFilter />
              <WorkflowAssigneeFilter />
            </>
          )}
          {!isNoFilterApplied && (
            <Button
              type="text"
              size="small"
              onClick={handleClear}
              className={s.clearBtn}
            >
              Clear filters
            </Button>
          )}
        </>
      )}
    </div>
  )
}

export default Filters
